import { PeriodSelectorOptionWithDates } from '../models/components/ChartStore';
import isChartPeriodSelected from './isChartPeriodSelected';

export default function getSelectedChartPeriod(
    periods: Array<PeriodSelectorOptionWithDates>,
    startDate?: string,
    endDate?: string
) {
    return [...periods]
        .reverse()
        .find(period => isChartPeriodSelected(period, startDate, endDate));
}



// WEBPACK FOOTER //
// ./src/utils/getSelectedChartPeriod.ts